import { render, staticRenderFns } from "./Marki.vue?vue&type=template&id=989a7812&scoped=true&"
import script from "./Marki.vue?vue&type=script&lang=js&"
export * from "./Marki.vue?vue&type=script&lang=js&"
import style0 from "./Marki.vue?vue&type=style&index=0&id=989a7812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989a7812",
  null
  
)

export default component.exports